import moment from "moment";

const DownloadContainer = ({ digitalIdentity, info, history }) => {
  // Function to convert JSON to CSV
  const getFormattedCaptureTime = (item) => {
    const captureTime = item?.capture_time;
    let formattedCaptureTime = "";
    if (captureTime) {
      const isValid = moment(captureTime, "HH:mm:ss.SSS", true).isValid();
      if (isValid)
        formattedCaptureTime = moment(captureTime, "HH:mm:ss.SSS").format(
          "HH:mm",
        );
    }
    return formattedCaptureTime;
  };
  const jsonToCSV = () => {
    const keys = [
      "Controller",
      "Customer Scope",
      "Type",
      "Value",
      "Purpose",
      "Legal Basis",
      "Status",
      "Status Reason",
      "Last Status Change",
      "Collection Channel",
      "Created Date",
      "Capture Date",
      "Expiry Date",
      "Modified",
      "Time Zone",
      "Update Channel",
      "Collector Email",
      "Signature Link",
      "Statement Link",
      "Document Version",
      "Commit Link",
      "Unsub Trigger Brand ID",
      "Unsub Trigger Content ID",
      "Valid From",
      "Valid To",
      "Capture Time",
      "Capture Source",
    ];

    // CSV rows initialization
    const csvRows = [];

    // Add the header row
    csvRows.push(keys.join(","));

    // Add the second row with custom values under the same keys
    const formattedInfoCaptureTime = getFormattedCaptureTime(info);
    const customValues = [
      digitalIdentity?.controller_code || "",
      digitalIdentity?.customer_scope || "",
      digitalIdentity?.type || "",
      digitalIdentity?.value || "",
      info?.global_purpose || "",
      info?.initial_legal_basis || "",
      info?.status || "",
      info?.status_reason || "",
      info?.last_status_change_datetime
        ? moment
            .utc(info?.last_status_change_datetime)
            .local()
            .format("DD.MM.YYYY HH:mm")
        : "",
      info?.collection_channel || "",
      info?.created_datetime
        ? moment.utc(info?.created_datetime).local().format("DD.MM.YYYY HH:mm")
        : "",
      info?.capture_date
        ? moment.utc(info?.capture_date).format("DD.MM.YYYY")
        : "",
      info?.expiry_date
        ? moment.utc(info?.expiry_date).local().format("DD.MM.YYYY")
        : "",
      info?.last_modified_datetime
        ? moment
            .utc(info?.last_modified_datetime)
            .local()
            .format("DD.MM.YYYY HH:mm")
        : "",
      "UTC" + moment().format("Z"),
      info?.last_update_channel || "",
      info?.collector_email || "",
      info?.signature_link || "",
      info?.statement_url || "",
      info?.document_version_number || "",
      info?.commit_hash
        ? `https://github.com/bayer-int/consent-management-ng-documents/tree/${info?.commit_hash}`
        : "",
      info?.unsubscribe_trigger_brand_id || "",
      info?.unsubscribe_trigger_content_id || "",
      info?.valid_from
        ? moment.utc(info?.valid_from).local().format("DD.MM.YYYY HH:mm")
        : "",
      info?.valid_to
        ? moment.utc(info?.valid_to).local().format("DD.MM.YYYY HH:mm")
        : "",
      formattedInfoCaptureTime,
      info?.capture_source || "",
    ];

    // Push the custom values as the second row
    csvRows.push(customValues.join(","));

    // Now process the rest of your history data
    history.forEach((row) => {
      const formattedCaptureTime = getFormattedCaptureTime(row);
      const values = [
        digitalIdentity?.controller_code || "",
        digitalIdentity?.customer_scope || "",
        digitalIdentity?.type || "",
        digitalIdentity?.value || "",
        row?.global_purpose || "",
        info?.initial_legal_basis || "",
        row?.status || "",
        row?.status_reason || "",
        row?.last_status_change_datetime
          ? moment
              .utc(row?.last_status_change_datetime)
              .local()
              .format("DD.MM.YYYY HH:mm")
          : "",
        row?.collection_channel || "",
        row?.created_datetime
          ? moment.utc(row?.created_datetime).local().format("DD.MM.YYYY HH:mm")
          : "",
        row?.capture_date
          ? moment.utc(row?.capture_date).format("DD.MM.YYYY")
          : "",
        row?.expiry_date
          ? moment.utc(row?.expiry_date).local().format("DD.MM.YYYY")
          : "",
        row?.last_modified_datetime
          ? moment
              .utc(row?.last_modified_datetime)
              .local()
              .format("DD.MM.YYYY HH:mm")
          : "",
        "UTC" + moment().format("Z"),
        row?.last_update_channel || "",
        row?.collector_email || "",
        row?.signature_link || "",
        row?.statement_url || "",
        row?.document_version_number || "",
        row?.commit_hash
          ? `https://github.com/bayer-int/consent-management-ng-documents/tree/${row?.commit_hash}`
          : "",
        row?.unsubscribe_trigger_brand_id || "",
        row?.unsubscribe_trigger_content_id || "",
        row?.valid_from
          ? moment.utc(row?.valid_from).local().format("DD.MM.YYYY HH:mm")
          : "",
        row?.valid_to
          ? moment.utc(row?.valid_to).local().format("DD.MM.YYYY HH:mm")
          : "",
        formattedCaptureTime,
        row?.capture_source || "",
      ];
      csvRows.push(values.join(","));
    });

    return csvRows.join("\n");
  };

  const downloadCSV = () => {
    const csv = jsonToCSV();
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().replace(/[-T:.]/g, "");
    link.download = `${info?.global_purpose}-${formattedDate}.csv`;
    link.click();

    window.URL.revokeObjectURL(url);
  };
  return (
    <div
      style={{
        textAlign: "right",
      }}
    >
      <div
        style={{
          color: "var(--theme-accent)",
          fontSize: 14,
          fontWeight: 500,
          padding: 5,
          cursor: "pointer",
        }}
        onClick={downloadCSV}
      >
        Download History
      </div>
    </div>
  );
};

export default DownloadContainer;
